import {ReportingService, SelectedAccount} from '@reporting/reporting.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {CheckboxGroupComponent, DatePipe, LoadComponent} from '@brunata-angular/ui';
import {InputTextGroupComponent} from '@brunata-angular/ui';
import {
    FormBuilder,
    FormControl,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ReportingAccountWithAttachments} from '../report-consumers-upload.service';
import {
    AppValidators,
    EMAIL_MAX_LENGTH,
    TranslatePipe,
    TranslateService,
} from '@brunata-angular/util';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-approve-uploaded-consumer-data',
    templateUrl: './approve-uploaded-consumer-data-modal.component.html',
    styleUrl: './approve-uploaded-consumer-data-modal.component.scss',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CheckboxGroupComponent,
        TranslatePipe,
        DatePipe,
        LoadComponent,
        InputTextGroupComponent,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApproveUploadedConsumerDataModalComponent {
    @Input() periodId: string | undefined;
    @Input() account: ReportingAccountWithAttachments | undefined;
    @Input() selectedAccount: SelectedAccount | undefined;
    protected readonly emailMaxLength = EMAIL_MAX_LENGTH;
    formGroup = this.formBuilder.group({
        sendEmail: new FormControl<boolean>(false),
        email: [{value: null, disabled: true}, [Validators.required, AppValidators.email]],
    });

    constructor(
        public activeModal: NgbActiveModal,
        private reportingService: ReportingService,
        private formBuilder: FormBuilder,
        private translateService: TranslateService,
        private toastr: ToastrService,
    ) {
        this.formGroup.controls.sendEmail.valueChanges
            .pipe(takeUntilDestroyed())
            .subscribe(sendReceiptByMail => {
                if (sendReceiptByMail != null && sendReceiptByMail) {
                    this.formGroup.controls.email.enable();
                } else {
                    this.formGroup.controls.email.disable();
                }
            });
    }

    approve(): void {
        this.formGroup.markAllAsTouched();
        if (
            this.formGroup.valid &&
            this.periodId != null &&
            this.selectedAccount != null &&
            this.selectedAccount.building.buildingNo != null &&
            this.selectedAccount.account.accountPeriodId != null
        ) {
            this.reportingService
                .approveConsumerReporting(
                    this.selectedAccount.building.buildingNo,
                    this.periodId,
                    this.selectedAccount.account.accountPeriodId,
                    this.formGroup.controls.email.value,
                )
                .subscribe(() => {
                    this.toastr.success(
                        this.translateService.translate('reporting_CONSUMER_LIST_APPROVED'),
                    );
                    this.activeModal.close();
                });
        }
    }
}
